import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { CrmAccess } from '@/lib/types';

/** O link do CRM muda pouco (vale 7 dias): uma consulta a cada 5 min basta, e falha não insiste. */
const STALE_MS = 5 * 60_000;

export const useCrmAccess = () =>
  useQuery({
    queryKey: ['migracao'],
    queryFn: () => api.get<CrmAccess>('/api/migracao'),
    staleTime: STALE_MS,
    retry: false,
  });

/** Na tela de entrar: o aviso está ligado? (rota pública, sem link nenhum) */
export const useMigrationOn = () =>
  useQuery({
    queryKey: ['migracao', 'ligado'],
    queryFn: () => api.get<{ ligado: boolean }>('/api/migracao/ligado'),
    staleTime: STALE_MS,
    retry: false,
  });
